import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
// Components
import HeroImage from "../HeroImage/HeroImage"
import Footer from "../Footer/Footer"
import Newsletter from "../Newsletter/Newsletter"
// Styles
import { Container } from "./PageSectionEmpty.styles"

const PageSectionEmpty = ({ heroImageNumber }) => {
   const [heroHeight, setHeroHeight] = useState("100svh")
   const [isPortrait, setIsPortrait] = useState(
      window.innerHeight > window.innerWidth
   )

   useEffect(() => {
      const handleResize = () => {
         const newsletterElement = document.getElementById("newsletter")
         const footerElement = document.getElementById("footer")

         const footerHeight = footerElement?.offsetHeight || 0
         const newsletterHeight = newsletterElement?.offsetHeight || 0
         const totalHeight = footerHeight + newsletterHeight

         setHeroHeight(`calc(100svh - ${totalHeight}px)`)
         setIsPortrait(window.innerHeight < 2 * totalHeight)
      }

      handleResize()
      window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
   }, [])

   return isPortrait ? (
      <>
         <Container>
            <HeroImage imageNumber={heroImageNumber} imageHeight={"100svh"} />
         </Container>
         <Container>
            <Newsletter />
            <Footer />
         </Container>
      </>
   ) : (
      <Container>
         <HeroImage imageNumber={heroImageNumber} imageHeight={heroHeight} />
         <Newsletter />
         <Footer />
      </Container>
   )
}

PageSectionEmpty.propTypes = {
   heroImageNumber: PropTypes.number,
}
export default PageSectionEmpty
